import React, { useState } from 'react';
import { PageSubmenu } from '../../components/common/Submenu';
import PasswordManager from '../../components/settings/password';
import Create from '../../components/settings/bank/create';
import { BankacctIcon, TitleIcon, SettingsProfile, KeyIcon, SubscriptionBlueCheck } from '../../assets/icons';
import PaymentIcon from '../../assets/icons/paymentIcon';
import { ViewProfile } from '../../components/settings/index';
import { GroupButton } from '../../components/common';
import EditIcon from '../../assets/icons/EditIcon';
import { PaymentManager } from '../../components/settings/payment';
import { CreateEditProfile } from '../../components/settings/profile/Edit';
import { BudgetManager } from '../../components/settings/expense';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import BankAccountManager from '../../components/settings/bank';
import Subscription from '../../components/settings/Subscription';
export const Settings = () => {
  const [tab, setTab] = useState<string>('profile');
  const [showEditProfile, setShowEditProfile] = useState<boolean>(false);
  const [showNewEditModal, setShowNewEditModal] = React.useState<boolean>(false);
  const [submenuTab, setSubmenuTab] = useState<string>('password');
  const [budgetSubmenuTab, setBudgetSubmenuTab] = useState<string>('expense');
  const [paymentSubmenuTab, setPaymentSubmenuTab] = useState<string>('viewPayment');
  const [bankSubmenuTab, setBankSubmenuTab] = useState<string>('bankAccount');
  const [activeTab, setActiveTab] = useState<string>('profile');

  const navigate = useNavigate();
  const location = useLocation();

  React.useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const activeTab = searchParams.get('tab');
    if (activeTab) {
      setTab(activeTab);
    }
  }, [location]);

  const componentMapper = () => {
    switch (tab) {
      case 'profile':
        return <ViewProfile />;
      case 'password':
        return <PasswordManager submenuTab={submenuTab} onBack={() => setSubmenuTab('password')} />;
      // case 'payment':
      //   return (
      //     <PaymentManager
      //       submenuTab={submenuTab}
      //       paymentSubmenuTab={paymentSubmenuTab}
      //       onBack={() => setSubmenuTab('payment')}
      //     />
      //   );
      case 'expense':
        return (
          <BudgetManager
            submenuTab={submenuTab}
            budgetSubmenuTab={budgetSubmenuTab}
            onBack={() => setSubmenuTab('expense')}
          />
        );
      case 'bankAccount':
        return (
          <BankAccountManager
            submenuTab={submenuTab}
            bankSubmenuTab={bankSubmenuTab}
            onBack={() => setSubmenuTab('bankAccount')}
          />
        );
      case 'subscription':
        return (
            <Subscription
            submenuTab={submenuTab}
            bankSubmenuTab={bankSubmenuTab}
            onBack={() => setSubmenuTab('bankAccount')}
            />
        )
    }
  };

  const handleTabClick = (newTab: string) => {
    setTab(newTab);
    setSubmenuTab('password');
    navigate(`/settings?tab=${newTab}`);
  };

  const handleTabChange = (tab: any) => {
    setActiveTab(tab);
  };

  return (
    <div className="container h-full">
      <div className="flex justify-start font-bold lg:text-[20px] text-[18px] md:text-[20px]  text-[#000000]">Settings</div>
      <div className=" gap-[8px]  ">
        <div className="text-[14px] ">
          <PageSubmenu
            activeTab={tab}
            tabs={[
              {
                label: 'Profile Information',
                icon: <SettingsProfile />,
                tab: 'profile',
                onClick: () => handleTabClick('profile'),
             
              },
              {
                label: 'Change Password',
                icon: <KeyIcon />,
                tab: 'password',
                onClick: () => handleTabClick('password'),
              },
              // { label: 'Payments', 
              // icon: <PaymentIcon />, 
              // tab: 'payment', 
              // onClick: () => handleTabClick('payment') },
              {
                label: 'Bank Account',
                icon: <BankacctIcon />,
                tab: 'bankAccount',
                onClick: () => handleTabClick('bankAccount'),
              },
              {
                label: 'Expense Budget',
                icon: <TitleIcon />,
                tab: 'expense',
                onClick: () => handleTabClick('expense'),
              },
              {
                label: 'Subscription',
                icon: <SubscriptionBlueCheck />,
                tab: 'subscription',
                onClick: () => handleTabClick('subscription'),
              },
            ]}
            onTabChange={handleTabChange}
          />
        </div>
        <hr className='border-b-1 lg:mt-[-1.5em] md:mt-[-1.5em] mt-[-0.8em] w-[1600px]  ml-[-3em] border-[#A4A4A4]'/>
        <div className="w-full mt-[2em] " />
        {tab === 'profile' ? (
          <ViewProfile />
        ) : (
          componentMapper()
        )}
      
      </div>
    </div>
  );
  
};
